import { useEffect, useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/architecture-apartment.jpg";
import api from "api/api";
import { AUTH_LOGIN, USER_INFO } from "constants/ApiRoutes";
import { useForm } from "react-hook-form";
import { Box, Modal, Typography } from "@mui/material";
import MDModal from "components/MDModal/";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();
  //   const [tenant, setTenant] = useState({});
  const navigation = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  const login = watch("login");
  const password = watch("password");

  const storeData = async (key, data) => {
    try {
      const jsonToken = JSON.stringify(data);
      return await localStorage.setItem(`${key}`, data);
    } catch (error) {
      console.log(error);
    }
  };

  const verifyUserInfo = async () => {
    await api.get(USER_INFO).then((response) => {
      const { tenants, ...user } = response.data[0];
      console.log(tenants);
      if (tenants.length == 1) {
        user.tenant_id = tenants[0].id;
        storeData("user", JSON.stringify(user));
        return redirectToDashboard();
      }
      //   return redirectToDashboard(tenants, setTenant);
    });
  };

  const redirectToDashboard = (tenants) => {
    return navigation("/dashboard", { tenants: tenants });
  };

  const saveLoginRememberMe = (data) => {
    localStorage.setItem("login", JSON.stringify(data));
  };

  const loginUser = async (data) => {
    setButtonDisabled(true);
    await api
      .post(AUTH_LOGIN, {
        login: data.login,
        password: data.password,
      })
      .then((response) => {
        const { token } = response.data;
        storeData("token", token);

        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        verifyUserInfo();
        redirectToDashboard();
      })
      .catch((error) => {
        setIsOpen(true);
        setTitle("Login Inválido");
        setMsg("Login e/ou Senha Inválidos");
      })
      .finally(() => {
        setButtonDisabled(false);
      });
  };

  const onHandleSubmit = (data) => {
    rememberMe === true ? saveLoginRememberMe(data) : localStorage.removeItem("login");
    loginUser(data);
  };

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleModal = () => setIsOpen(!isOpen);

  const handleInputs = () => {
    if (login.length > 0 && password.length > 0) {
      return true;
    }
  };

  //   useEffect(() => {
  //     user.tenant_id = tenant.id;
  //     storeData("user", JSON.stringify(user));
  //   }, [tenant]);

  useEffect(() => {
    // if (login.length > 0 && password.length > 0) setButtonDisabled(false);
    const login = JSON.parse(localStorage.getItem("login"));
    if (login !== null) {
      reset(login);
      setRememberMe(true);
    } else {
      setRememberMe(false);
      localStorage.removeItem("login");
    }
  }, []);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" onSubmit={handleSubmit(onHandleSubmit)} role="form">
            <MDBox mb={2}>
              <MDInput type="login" {...register("login")} label="Email" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" {...register("password")} label="Password" fullWidth />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Lembrar Me
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                disabled={buttonDisabled}
                fullWidth
              >
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDModal isOpen={isOpen} handleModal={handleModal}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {msg}
        </Typography>
        <MDButton variant="gradient" color="info" onClick={() => setIsOpen(false)} fullWidth>
          Fechar
        </MDButton>
      </MDModal>
    </BasicLayout>
  );
}

export default Basic;
